import { Paper, Typography } from '@mui/material';
import styles from './NumberAnswer.styles';

type NumberAnswerComponentProps = {
  answer: string;
  limit?: number;
};

const NumberAnswerComponent = function ({
  answer,
  limit = 5,
}: NumberAnswerComponentProps): JSX.Element {
  return (
    <Paper variant="outlined" sx={styles.container}>
      <Typography fontSize={28} fontWeight={700} data-testid="question-response">
        {answer}
        <Typography component="span" color="primary.light">
          /{limit}
        </Typography>
      </Typography>
    </Paper>
  );
};

export default NumberAnswerComponent;
